import { Button } from '@vzmi/shp_shared_compo'
import Editor from '../../../Proposal/Common/ProposalForm/Editor/Editor'
import { Field } from '../../../Common/forms'
import { RFSelectInputField, RadioGroupInputField } from '../../../Common/Form'
import BatchApplyCollapseBlock from '../BatchApplyCollapseBlock'
import { APPLY_RADIO_OPTIONS, APPLY_ADD_OPTIONS, APPLY_FIELD } from '../../../../constants/batchProposals'
import styles from './index.css'

const BatchApplyRows = props => {
  const { readOnly, disabled, onUpdate } = props

  return (
    <BatchApplyCollapseBlock>
      <div
        className={styles.content}
        data-role='batch-apply-rows'
      >
        <Editor
          fieldName={APPLY_FIELD.COPY}
          className={styles.copy}
          readOnly={readOnly}
          isBatchApply
        />
        <div className={styles.operate}>
          <Field
            name={APPLY_FIELD.OPERATES}
            className={styles.radio}
            component={RadioGroupInputField}
            options={APPLY_RADIO_OPTIONS}
            disabled={readOnly}
          />
          <div className={styles.optionsBlock}>
            <Field
              name={APPLY_FIELD.OPTIONS}
              component={RFSelectInputField}
              className={styles.addTypeSelect}
              options={APPLY_ADD_OPTIONS}
            />
            <p className={styles.text}>完全符合才會被移除</p>
          </div>
        </div>
        <div className={styles.buttonBlock}>
          <Button
            className={styles.button}
            type='button'
            size='large'
            disabled={disabled}
            onClick={() => onUpdate()}
          >
            確認套用
          </Button>
          <p>套用到所有賣場上</p>
        </div>
      </div>
    </BatchApplyCollapseBlock>
  )
}

export default BatchApplyRows
